if (window.location.pathname === "/cart") {
const miniCart = document.querySelector("#mini-cart");
  if (miniCart) {
    miniCart.remove();
    setTimeout(() => {
        BSS_B2B.nt.initFunction()
        document.dispatchEvent(new Event("DOMContentLoaded"));
    },500)
  }
}
